import { Box, Grid, Spinner, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { InfiniteLoader } from 'modules/core/hooks/usePaginatedQuery'
import i18n from 'modules/core/lib/i18n'

import Item from 'modules/product_updates/components/ListSection/_Item'
import { useGetProductUpdates } from 'modules/product_updates/hooks/useGetProductUpdates'

type Props = {
  selectedModule?: string
  isLaunched: boolean
}

const ListSection = ({ selectedModule, isLaunched }: Props) => {
  const { productUpdates, controls, loading } = useGetProductUpdates({
    alreadyReleased: isLaunched,
    moduleIdentifier: selectedModule,
  })

  if (loading) {
    return (
      <Box alignItems="center">
        <Spinner />
      </Box>
    )
  }

  if (productUpdates.length === 0) {
    return (
      <Box alignItems="center">
        <Text.Normal>{i18n.t('product_updates.filters.no_results')}</Text.Normal>
      </Box>
    )
  }

  const sortedProductUpdates = isLaunched
    ? productUpdates
    : productUpdates.sort((a, b) => moment(a.releaseDate).diff(b.releaseDate))

  return (
    <InfiniteLoader controls={controls}>
      <Grid variant="large">
        {sortedProductUpdates.map((update) => (
          <Item key={update.id} {...update} />
        ))}
      </Grid>
    </InfiniteLoader>
  )
}

export default ListSection
